import 'cirrus-ui'
import { NavigationItem } from './NavigationItem'
import { NavigationContext } from '../contexts/NavigationContext'
import { useContext } from 'react'

var MenuItems = [
    { key: 'home', text: 'Inicio', url: './', active: true },
    { key: 'project', text: 'Proyectos', url: './projects', active: false },
    { key: 'contact', text: 'Contacto', url: './contact', active: false }
]

export function NavigationMenu() {

    const context = useContext(NavigationContext);


    return (
        <div className={context.isToggleOn ? 'header-nav active' : 'header-nav'} id="header-menu">
            <div className="nav-right">
                {MenuItems.map((item) => <NavigationItem {...item} />)}
            </div>
        </div>
    )
}
